<template>
    <div class="liquid-circle">
        雪亮圈子
    </div>
</template>

<script>
    export default {
        name: "liquid-circle"
    }
</script>

<style scoped>

</style>